import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { addIntercomMsg } from "../../../../../utils";
import { MediaBaseUrl } from "../../../../../actions/api";

const EXIT_POPUP_SHOWN_KEY = "onboardingExitPopupShown";

const isAlreadyShown = () => {
  try {
    return localStorage.getItem(EXIT_POPUP_SHOWN_KEY) === "1";
  } catch (e) {
    return false;
  }
};

const markAsShown = () => {
  try {
    localStorage.setItem(EXIT_POPUP_SHOWN_KEY, "1");
  } catch (e) {}
};

const ExitPopup = ({ moveAction, noFeedCrt}) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const shownRef = useRef(isAlreadyShown()); // once per session: skip if it already showed

  useEffect(() => {
    if (shownRef.current) return;

    const handleMouseLeave = (event) => {
      if (event.clientY <= 0 && !shownRef.current) {
        shownRef.current = true;
        markAsShown();
        setIsOpen(true);
        document.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
    const handleBeforeUnload = (event) => {
      setIsOpen(false);
      event.preventDefault();
      event.returnValue = 'Are you sure?'; // Some browsers require setting returnValue for the prompt to show up
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleExit = (type) => {
    if(type < 3) {
      if(moveAction) moveAction(type);
    } else addIntercomMsg(`Hi! 👋\nI need help creating my first social feed.\nHere's what I want to show:\nNetwork Name - \nAdditional Details -\nThanks! 🙌`);
    setIsOpen(false);
  };

  const handleCancel = () => {
    navigate(1); // Move forward to prevent unintended navigation
    setIsOpen(false);
  };
  
  return (
    <Modal show={isOpen} size="md" backdrop="static" onHide={handleCancel} centered>
      <Modal.Body className="text-center pb-0">
        <button type="button" className="btn-close position-absolute" style={{right: "20px", top: "20px"}} onClick={() => setIsOpen(false)} aria-label="Close"></button>
        <div className="row py-5">
          <div className="col-lg-12">
            <div className="upgredeMain text-center">
              <div className="permissionMsg mt-4 px-4">
                <h4 style={{fontSize: "24px"}} className="ErrorMsg">{noFeedCrt ? "Having trouble creating your feed?" : "Your feed is ready—let's get it live!"}</h4>
                <p className="msgSec">{noFeedCrt ? "Let us set it up for you while you relax — or you can give it another go!" : "Just one step left: embed it on your website to start engaging your visitors."}</p>
              </div>
              <div className="Errorimage pb-3"><img style={{ maxWidth: "75%" }} isPrefix={true} src={noFeedCrt ? `${MediaBaseUrl}error/add-social-feed.png` : 'https://taggbox.com/wp-content/uploads/2024/11/publish.png'} className="img-fluid" width={500} height={300} /></div>
              <div style={{ marginTop: "30px" }} className="buttonUpgred mb-sm-5 mb-3">
                <button onClick={()=>handleExit(1)} className="commanBtn btn btn-light border px-5 d-inline-block" data-factors-click-bind="true">{noFeedCrt ? "Try Again" : `🎨 I Want to Customize It`}</button>
                <button onClick={()=>handleExit(noFeedCrt ? 3 : 2)} className="commanBtn btn btn-primary ms-3 px-5 d-inline-block" data-factors-click-bind="true">{noFeedCrt ? `Create Feed for Me 👉` : "Get Embed Code"}</button>
              </div>
              {!noFeedCrt ? <div><span style={{margin: "20px 0 0 0", display: "block", textAlign: "end"}}><strong> Need help?</strong> <span className="cursor-pointer" onClick={() => {
                if(window.Intercom) window.Intercom('show');
                setIsOpen(false);
              }}>Talk to Us!</span></span></div> : null}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExitPopup;